export enum LAYOUT_TYPES {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}

export enum LAYOUT_COLOR_TYPES {
  LIGHTMODE = 'light',
  DARKMODE = 'dark',
}

export enum LAYOUT_MODE_TYPES {
  FLUID = 'fluid',
  BOXED = 'boxed',
  DETACHED = 'detached',
}

export enum TOPBAR_COLOR_TYPES {
  LIGHT = 'light',
  DARK = 'dark',
  BRAND = 'brand',
}

export enum MENU_COLOR_TYPES {
  LIGHT = 'light',
  DARK = 'dark',
  BRAND = 'brand',
}

export enum SIDEBAR_SIZE_TYPES {
  DEFAULT = 'default',
  COMPACT = 'compact',
  CONDENSED = 'condensed',
  HOVER = 'sm-hover',
  FULL = 'full',
  FULLSCREEN = 'fullscreen',
}

export enum LAYOUT_POSITION_TYPES {
  FIXED = 'fixed',
  SCROLLABLE = 'scrollable',
}
